import { useEffect, useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './components/Dashboard';
import { Inbox } from './components/Inbox';
import { Decision } from './components/Decision';
import { DailyPlan } from './components/DailyPlan';
import { Landing } from './components/Landing';
import { UserMenu } from './components/UserMenu';
import { useAuth } from './auth';
import { useI18n } from './i18n';
import { api } from './api';

export type View = 'dashboard' | 'inbox' | 'decision' | 'daily';

const DEMO_FLAG = 'execos.demo';

export default function App() {
  const [view, setView] = useState<View>('dashboard');
  const { user, loading, refresh } = useAuth();
  const { t } = useI18n();
  const [demo, setDemo] = useState<boolean>(() => {
    try {
      return localStorage.getItem(DEMO_FLAG) === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('auth') === 'ok') {
      void refresh();
      params.delete('auth');
      const qs = params.toString();
      const url = window.location.pathname + (qs ? `?${qs}` : '');
      window.history.replaceState({}, '', url);
    }
  }, [refresh]);

  const enterDemo = () => {
    try {
      localStorage.setItem(DEMO_FLAG, '1');
    } catch {
      /* noop */
    }
    setDemo(true);
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-dot" />
      </div>
    );
  }

  const authed = user?.provider === 'yandex';
  if (!authed && !demo) {
    return <Landing onDemo={enterDemo} />;
  }

  return (
    <div className="app">
      <Sidebar current={view} onChange={setView} />
      <main className="main">
        {!authed && (
          <div className="demo-banner">
            <span>{t('auth.demoBanner')}</span>
            <a className="btn btn-primary btn-sm" href={api.yandexSignInUrl()}>
              {t('auth.demoBanner.cta')}
            </a>
          </div>
        )}
        <div className="main-user-row">
          <UserMenu />
        </div>
        {view === 'dashboard' && <Dashboard />}
        {view === 'inbox' && <Inbox />}
        {view === 'decision' && <Decision />}
        {view === 'daily' && <DailyPlan />}
      </main>
    </div>
  );
}
